import React from 'react';
import { FaRegGem } from 'react-icons/fa';
import { RxValueNone } from 'react-icons/rx';
import { clientNetwork, cryptoCashCoreAddress } from '../../lib/constants';
import { network } from '../../services/auth';
import { useConnect } from '@stacks/connect-react';
import { AnchorMode, listCV, uintCV } from '@stacks/transactions';

const SingleClaim = ({ navTo, reward, cycleId, setConfirmTx, setShowConfirmModal }) => {
    const { doContractCall } = useConnect();

    const claimMinReward = () => {
        doContractCall({
            contractAddress: cryptoCashCoreAddress.split('.')[0],
            contractName: cryptoCashCoreAddress.split('.')[1],
            functionName: 'claim-stacking-reward-list',
            functionArgs: [listCV([uintCV(cycleId)])],
            network: network({ network: clientNetwork }),
            anchorMode: AnchorMode.Any,
            onFinish: ({ txId }) => {
                setConfirmTx(txId);
                setShowConfirmModal(true);
            },
            onCancel: () => {
                console.log("Action cancelled");
            }
        })
    }

    return (
        <div id="stack-iterms" >
            <div id="reward-status-container">
                {/* RENDER THE APPROPRIATE SECTION BASED ON STATUS */}
                {/* if the status is 'pending' or 'looking' */}
                {/* {stackRewardState === "pending" && <BsHourglassSplit />} */}
                {/* if the status is 'unclaimed' */}
                {/* bind the onclick of this button to the 'claim-mining-reward' function of the 'live' version of .derupt-core-yyyymmdd per the 'get-derupt-core-contract' via the .derupt-feed contract getter */}
                {/* {reward === "unclaimed" && <button className='reward-button' onClick={claimMinReward}><FaRegGem /></button>} */}
                {reward === true && <button className='reward-button' onClick={claimMinReward}><FaRegGem /></button>}
                {reward === false && <RxValueNone />}

                {/* if the status is 'lost'  */}
                {/* {reward === "lost" && <RxValueNone />} */}

                {/* if the status is 'claimed' */}
                {/* {reward === "claimed" && <FaRegGem />} */}

            </div>

        </div>

    );
};

export default SingleClaim;